module.exports = __webpack_public_path__ + "static/img/retail5.21e43b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/retail5.png
// module id = J8mX
// module chunks = 2